export default "__VITE_ASSET__BfPnF7u7__"